angular.module('admin')
  .controller('AgentHomeDetailCtrl', ['$scope', '$state', 'UserService', 'HomeActivity', 'HomeService', 'AccountService', 'AgentService', 'Dictionary', 'ActivityDictionary', '$q', 'HelperService', 'UtilService', '$timeout', 'PageNotificationService', 'FEATURES',
    function ($scope, $state, UserService, HomeActivity, HomeService, AccountService, AgentService, Dictionary, ActivityDictionary, $q, helpers, utils, $timeout, PageNotificationService, FEATURES) {

    $scope.accountService = AccountService;
    $scope.currentModal = false;
    $scope.newUser = {};
    $scope.testDigestEmail = AccountService.getAgent('email');
    $scope.loading = true;
    $scope.refreshingUsers = false;
    $scope.emailTipOpen = false;
    $scope.showV2Digest = false;
    $scope.answers = [];

    var dictionary = new Dictionary();
    var activityDictionary = new ActivityDictionary();
    var homeId = $state.params.homeId;
    var agentId = $state.params.id;
    var clientId = $state.params.clientId;
    let usersRefreshCount = 0;

    $scope.refreshHomeActivity = function(){
      if(!$scope.home.users && $scope.home.users.length) return;
      _.each($scope.home.users, function(user,i){
        user.loading = true;
        user.activity = [];
        HomeActivity.getUserHomeActivity(user.id,homeId).then(
          function success(data){
            user.loading = false;
            user.activity = data;
            user.isActive = _.filter(user.activity, helpers.isActiveFilter).length;
            $scope.combineStreams();
          },function error(err){
            utils.trackException('Admin Refresh Home Activity', err);
          });
      });
    };

    $scope.setCurrentAgent = function(){
      return AgentService.getOne(agentId)
        .then(function(agent){
          $scope.agent = agent;
          $scope.showV2Digest = _.contains(agent.features, FEATURES.DIGEST_V2);
          $scope.hasMortgageCoach = _.contains(agent.features, FEATURES.MORTGAGE_COACH);
        })
        .catch(function(e){
          $scope.error = 'There was an error loading your agent profile.';
        });
    };

    $scope.sendRealDigest = function(user){
      if(user)
        var users = [user];
      else
        var users = $scope.home.users;

      var names = _.pluck(users, 'first_name');
      var args = {
        users: _.pluck(users, 'id')
      };

      if(!args.users) return;

      if(!confirm('Send an email to '+names.join(' and ')+'?'))
        return;

      $scope.sending = true;

      HomeService.sendDigest($scope.home.id, args)
        .then(() => {
          $scope.refreshHomeActivity();
          $scope.home.emailOpen = false;
          $scope.sending = false;
          $scope.needsCMANotification = false;
        })
        .catch((err) => {
          $scope.sending = false;
          $scope.refreshHomeActivity();
          alert('There was an error sending the digest(s):' + err);
        });
    };

    $scope.sendTestDigest = function(){
      var email = $scope.testDigestEmail;

      if(!email) return;

      $scope.sendingTest = true;

      HomeService.sendDigestTest($scope.home.id, email)
        .then(() => {
          $scope.home.emailOpen = false;
          $scope.sendingTest = false;
        })
        .catch((err) => {
          $scope.sendingTest = false;
          alert(`There was an error sending the email(s): ${err}`);
        });
    };

    $scope.sendCMANotification = function(user){
      $scope.sendingCMANotification = true;

      HomeActivity
        .trackHome({'source':'agent','event':'cma-notify-client','userId':$scope.home.users[0].id,'homeId':homeId,'agentId':agentId})
        .then(function nextUser(data){
            if($scope.home.users.length > 1)
              return HomeActivity.trackHome({'source':'agent','event':'cma-notify-client','userId':$scope.home.users[1].id,'homeId':homeId,'agentId':agentId});
            else
              return data;
          })
        .then(function success(data){
            $scope.refreshHomeActivity();
            $scope.sendingCMANotification = false;
            $scope.needsCMANotification = false;
          },
          function error(err){
            $scope.refreshHomeActivity();
            $scope.sendingCMANotification = false;
            utils.trackException('Admin Send CMA Notification', err);
            console.log(err)
          });
    };

    $scope.refreshHome = function(){
      $q.all([
        HomeService.getAnswers(homeId),
        HomeService.getDetailedHome(homeId)
      ])
        .then(([answersResult, detailedResult]) => {
          $scope.setLastUpdatedHomeFacts(answersResult);
          return detailedResult;
        })
        .then(function(home){
          $scope.home = home;
          $scope.home.users = helpers.sortUsers($scope.home.users);
          $scope.refreshHomeActivity();
          $scope.setupCMA();
          $scope.cmaOpen = false;
          $scope.setUserTab(clientId);
          $scope.loading = false;
          $scope.setEmailValidationTimeout();
        })
        .catch(function(data){
          $scope.loading = false;
          $scope.error = 'There was an error loading this home.';
        });
    };

    $scope.refreshUsers = function(){
      $scope.refreshingUsers = true;
      usersRefreshCount++;

      HomeService.getUsers(homeId)
        .then(function(users){
          $scope.home.users = helpers.sortUsers(_.flatten(users));
          $scope.refreshingUsers = false;
          $scope.setEmailValidationTimeout();
        })
        .catch(function(data){
          $scope.error = 'There was an error loading these homeowners.';
        });
    };

    $scope.hasEmailsValidating = function(){
      return _.some($scope.home.users, {emailVerificationUpdatedAt: null});
    };

    $scope.setEmailValidationTimeout = function(){
      if(!$scope.hasEmailsValidating() || usersRefreshCount > 2)
        return;

      $timeout(() => {
        if($scope.currentModal || $scope.editUserNote) return;

        $scope.refreshUsers();
      }, 8000);
    };

    $scope.setLastUpdatedHomeFacts = function(answers) {
      $scope.answers = answers;
      if (_.isEmpty(answers)) {
        $scope.bedsBathsUpdated = undefined;
        $scope.saleFactsUpdated = undefined;
      } else {
        const physicalFacts = ['fact:bedrooms', 'fact:bathrooms', 'fact:finishedSqFt'];
        const saleFacts = ['fact:soldDate', 'fact:soldPrice'];
        const sortedAnswers = _.sortByOrder(answers, 'updated', 'desc');
        $scope.bedsBathsUpdated = _.result(_.find(sortedAnswers, answer => physicalFacts.includes(answer.question)), 'updated');
        $scope.saleFactsUpdated = _.result(_.find(sortedAnswers, answer => saleFacts.includes(answer.question)), 'updated');
      }
    };

    $scope.saveHome = function(){
      var args = {address:{ street: $scope.home.address.street, unit: $scope.home.address.unit, zip: $scope.home.address.zip}};
      $scope.formError = '';

      HomeService.save(args, homeId).then(
        function success(home){
          $scope.set('currentModal', false);
          $scope.refreshHome();
        }, function error(err){
          $scope.formError = err;
          utils.trackException('Admin Update Address', err);
        });
    };

    $scope.deleteHome = function(home, usersExistOnHome){
      var homeAddress = home.address.street
      var message = 'Are you sure you want to remove ' + homeAddress + '?';

      if(usersExistOnHome)
        message += ' If this client is linked to other properties, the client will NOT be removed.';

      if(!confirm(message))
        return;

      $scope.deletingHome = true;

      HomeService.remove(home.id).then(function success(){
          $scope.deletingHome = false;
          $state.go('agent.clients', {id: agentId});
          PageNotificationService.success(`${homeAddress} has been successfully deleted.`);
        }, function error(err){
          $scope.deletingHome = false;
          alert('Error:', err);
          utils.trackException('Admin Remove Home', err);
        });
    };

    $scope.closeEditModal = function(){
      $scope.set('currentModal', false);
      $scope.refreshHome();
    };

    $scope.onUserDelete = function(){
      $scope.closeEditModal();
      $scope.clientTabId = null;
    };

    $scope.setupCMA = function(){
      if($scope.lookup('cmaBuyersAgentPreferred'))
        $scope.preferredRea = $scope.home.sellingAgent;

      // TODO: we need a cma request model for this
      HomeActivity.getCmaRequest($scope.home.id)
        .then((activityItems) => {
          const requesterId = activityItems.length ? activityItems[0].userId : null;
          let users = _.filter($scope.home.users, function(user){
            return user.id === requesterId;
          });
          $scope.cmaRequester = users.length ? users[0] : $scope.home.users[0];
        });
    };

    $scope.setUserTab = function(id){
      if($scope.home.users && $scope.home.users.length)
        $scope.clientTabId = id || $scope.clientTabId || $scope.home.users[0].id;
    };

    $scope.lookup = function(prop,args){
      return dictionary[prop]($scope.home,args);
    };

    $scope.combineStreams = function(){
      var stream = [];
      _.each($scope.home.users, function(user){
        stream = stream.concat(user.activity);
      });
      return $scope.combinedStream = stream;
    };

    $scope.updateExternalData = function(){
      $scope.updatingHomeData = true;

      HomeService.updateExternalData(homeId)
        .then(function(){
          $scope.updatingHomeData = false;
          $scope.refreshHome();
        })
        .catch(function(err){
          $scope.updatingHomeData = false;
          alert('Error updating home' + err);
        });
    };

    $scope.recompileHome = function(){
      $scope.recompilingHome = true;

      HomeService.recompileHome(homeId)
        .then(function(){
          $scope.recompilingHome = false;
          $scope.refreshHome();
        })
        .catch(function(err){
          $scope.recompilingHome = false;
          alert('Error recompiling home' + err);
        });
    };

    $scope.deleteLoans = function(){
      if(!confirm('Delete loans?')) return false;

      $scope.deletingLoans = true;

      HomeService.deleteLoans(homeId)
        .then(function(){
          $scope.deletingLoans = false;
          $scope.refreshHome();
        })
        .catch(function(err){
          $scope.deletingLoans = false;
          alert('Error deleting loans' + err);
        });
    };

    $scope.resetCMA = function(){
      if(!confirm('Reset CMA: this will delete the CMA and all answers given by the client. Do it?')) return false;

      $scope.resettingCMA = true;

      HomeService.resetCMA(homeId)
        .then(function(home){
          $scope.resettingCMA = false;
          $scope.refreshHome();
        })
        .catch(function(err){
          $scope.resettingCMA = false;
          alert('Error:', err);
          utils.trackException('Admin Reset CMA', err);
        });
    };

    $scope.showCMA = function(){
      $scope.currentModal = 'cmaEntry';
    };

    $scope.hasSellingAgent = function(){
      try{
        return $scope.home.sellingAgent.datasources.rets.status === 'success';
      }catch(e){ return false; };
    };

    $scope.lookupActivity = function(prop,stream){
      stream = stream || $scope.combinedStream;
      return activityDictionary[prop](stream);
    };

    $scope.set = function(prop, val){
      $scope[prop] = val;
    };

    $scope.toggleProp = function(prop, scope, val){
      scope = scope || $scope;
      val = val || !scope[prop];

      scope[prop] = val;
    };

    $scope.updateUserNote = function(user){
      var args = {
        agent_note: user.agent_note
      };
      $scope.formError = '';

      UserService.save(args, user.id)
        .then(() => {
          $scope.editUserNote = false;
        }).catch((err) => {
          $scope.formError = err;
          utils.trackException('Admin Update User Note', err);
        });
    };

    $scope.removeUserNote = function(user){
      user.agent_note = "";
      var args = {
        agent_note: user.agent_note
      };
      $scope.formError = '';
      $scope.editUserNote = false;

      UserService.save(args, user.id)
        .catch((err) => {
          $scope.formError = err;
          utils.trackException('Admin Update User Note', err);
        });
    };

    $scope.showEquityHomePreview = function () {
      if (!$scope.home)
        return false;

      if ($scope.showV2Digest || !$scope.agent)
        return false

      const maximumLTV = 0.8;
      const minimumEquity = 25000;

      const fiveMonthsAgo = moment().subtract(5, 'months');
      const currentLoans = dictionary.currentLoansNoHelocs($scope.home)

      const hasLoanNewerThanFiveMonths = _.any(currentLoans, function (loan) {
        return moment(loan.date).isAfter(fiveMonthsAgo)
      })

      if (hasLoanNewerThanFiveMonths)
        return false

      const outstandingPrincipal = _.sum(currentLoans, function (loan) {
        return _.get(loan, 'progress.principal_left', 0)
      })

      const currentAvm = _.get($scope.home, 'metadata.homeValue')
      const leverageableEquity = (currentAvm * maximumLTV) - outstandingPrincipal

      return leverageableEquity > minimumEquity
    };

    $scope.hasLoansForRefi = function () {
      if (!$scope.home || !$scope.agent)
        return false
      
      const currentLoans = dictionary.currentLoansNoHelocs($scope.home)
      
      return currentLoans.length > 0     
    };
    
    $scope.hasLoanPastFiveMonthsForRefi = function () {
      if (!$scope.home || !$scope.agent)
        return false

      const fiveMonthsAgo = moment().subtract(5, 'months');
      const currentLoans = dictionary.currentLoansNoHelocs($scope.home)

      const hasLoanNewerThanFiveMonths = _.any(currentLoans, function (loan) {
        return moment(loan.date).isAfter(fiveMonthsAgo)
      })

      return !hasLoanNewerThanFiveMonths  
    };

    $scope.digestScheduledAtRange = function(user) {
      const digestScheduledAt = user.digestScheduledAt
      const startDate = moment(digestScheduledAt).format('M/DD')
      const endDate = moment(digestScheduledAt).add(10, 'days').format('M/DD')

      return `${startDate} - ${endDate}`
    };

    $scope.refreshHome();
    $scope.setCurrentAgent();
}]);
